
import { Component, Inject, OnInit } from '@angular/core';
import { MatSnackBar, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
    selector: 'app-toast-successfully',
    templateUrl: './toast-successfully.component.html',
    styleUrls: ['./toast-successfully.component.scss'],
})
export class ToastSuccessfullyComponent implements OnInit {
    isShow = true;
    toastData:any
    constructor(public snackBar: MatSnackBar, @Inject(MAT_SNACK_BAR_DATA) public data: any) { 
        this.toastData = data;
    }
   
    ngOnInit() {
      
    }

    ngOnDestroy(): void {
    }

    dismiss() {
        this.snackBar.dismiss();
    }
}
